module.exports = __webpack_public_path__ + "static/media/img1-2.9ed31293.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/nutricheck_foliar/ZN/img1-2.png
// module id = 2174
// module chunks = 3